export const environment = {
  production: false,
  baseUrl: window.location.origin,
    documentParserBaseUrl: 'https://ai-tools-api-bkg6ckb0f7c0bjf9.centralindia-01.azurewebsites.net',
  apis: {
    default: {
        // baseUrl: 'http://localhost:5062',
        baseUrl: 'https://app-gradpilots-dev01-gpafdfbvh3g0b6gr.centralindia-01.azurewebsites.net',
        url: `/api`,
        signalrNotificationHubUrl: '/notification',
        rootNamespace: 'gradpilots',
        olaPlaces: {
          url: 'https://api.olamaps.io/places/v1/autocomplete',
          apiKey: 'SNdVS3hpk7SrIdlIjfOasGemD0UIhhv7q43BiRQf'
        },
        countriesNow: {
          url: 'https://countriesnow.space/api/v0.1/countries/cities'
        }
    }
  },
  google: {
    clientId: '1067287891047-ibq2pgopbtsv68jqca1t7absq4cgimj5.apps.googleusercontent.com'
  },
    linkedin: {
  clientId: '86hzs9o8i47nnp',
  redirectUri: 'https://app-gradpilots-dev01-gpafdfbvh3g0b6gr.centralindia-01.azurewebsites.net/linkedin-callback'
}
}
